import React from "react";
import { GoogleLogin } from "react-google-login";
import { useTranslation } from "react-i18next";

import { useLoginThirdParty } from "../../apiHooks/auth";
import { googleSvg } from "../../svgs";

const clientID =
  "1096281413165-ip9bksrgmpn8sb1k1sk0uqjdhsm1ab1i.apps.googleusercontent.com";

const CustomGoogleAuth: React.FC = () => {
  // translation
  const { t } = useTranslation();

  const { loginThirdParty } = useLoginThirdParty();

  const loginThirdPartyUser = (data) => {
    loginThirdParty({
      params: {
        email: data.profileObj.email,
        username: data.profileObj.name,
        vendor_name: "2",
        vendor_id: data.profileObj.googleId,
        token: data.accessToken,
      },
    });
  };

  const onSuccess = (res) => {
    loginThirdPartyUser(res);
  };

  const onFailure = () => {};

  return (
    <GoogleLogin
      prompt="select_account"
      clientId={clientID}
      buttonText={t("login")}
      onSuccess={onSuccess}
      onFailure={onFailure}
      cookiePolicy="single_host_origin"
      render={(renderProps) => (
        <button onClick={renderProps.onClick} disabled={renderProps.disabled}>
          {googleSvg()} {t("googleAuth")}
        </button>
      )}
    />
  );
};

export default CustomGoogleAuth;
